module.exports = __webpack_public_path__ + "img/pony-express-hero.31d623e2.jpg";